/*
vip客服list
*/
let vipList = {
    ID: [
        {
            nickname: 'uplive topup',
            line: 'UP.LIVE',
            avatar: require('../../../images/vipcz/logo.png'),
            lineimg: require('../../../images/vipcz/line-topup.png')
        }
    ],
    PK: [
        {
            nickname: 'alee786',
            whatsapp: '+923017492611',
            wechat: 'Aleehussain786',
            avatar: require('../../../images/vipcz/alee.png'),
            weiimg: require('../../../images/vipcz/wei-alee786.png')
        }
    ],
    US: [
        {
            nickname: 'Rahul Anand',
            wechat: 'xian_uplive',
            //facebook:'xiankool@gmail.com',
            email: 'uplive.usa@gmail.com',
            avatar: require('../../../images/vipcz/Rahul.png'),
            weiimg: require('../../../images/vipcz/wei-Rahul.png')
        }
    ],
    JP: [
        {
            nickname: 'テイテイ(奶油)',
            wechat: 'uplivevipel',
            line: 'uplivevipel',
            avatar: require('../../../images/vipcz/naiyou.jpg'),
            lineimg: require('../../../images/vipcz/line-naiyou.png'),
            weiimg: require('../../../images/vipcz/wei-naiyou.png')
        }
    ],
    MY: [
        {
            nickname: 'Chuah',
            wechat: 'VIPCHUAH',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-chuah.png')
        },
        {
            nickname: 'James',
            wechat: 'weird_prince',
            line: '',
            avatar: require('../../../images/vipcz/logo.png'),
            lineimg: require('../../../images/vipcz/line-james.png'),
            weiimg: require('../../../images/vipcz/wei-james.png')
        },
         {
            nickname: 'Jie Lun',
            wechat: 'ww233700',
            line: 'uplivejay',
            avatar: require('../../../images/vipcz/logo.png'),
            lineimg: require('../../../images/vipcz/line-jielun.png'),
            weiimg: require('../../../images/vipcz/wei-jielun.png')
        },
        {
            nickname: 'CL',
            wechat: 'cl051296',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-cl.png')
        },
        {
            nickname: 'Roweena',
            wechat: 'Princessroweena',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-row.png')
        },
    ],
    SG: [
        {
            nickname: 'Chuah',
            wechat: 'VIPCHUAH',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-chuah.png')
        },
        {
            nickname: 'James',
            wechat: 'weird_prince',
            line: '',
            avatar: require('../../../images/vipcz/logo.png'),
            lineimg: require('../../../images/vipcz/line-james.png'),
            weiimg: require('../../../images/vipcz/wei-james.png')
        },
         {
            nickname: 'Jie Lun',
            wechat: 'ww233700',
            line: 'uplivejay',
            avatar: require('../../../images/vipcz/logo.png'),
            lineimg: require('../../../images/vipcz/line-jielun.png'),
            weiimg: require('../../../images/vipcz/wei-jielun.png')
        },
        {
            nickname: 'CL',
            wechat: 'cl051296',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-cl.png')
        },
        {
            nickname: 'Roweena',
            wechat: 'Princessroweena',
            avatar: require('../../../images/vipcz/logo.png'),
            weiimg: require('../../../images/vipcz/wei-row.png')
        },
    ],
    VN:[
        {
            nickname: 'Hoang Tam',
            facebook:'https://m.me/hoangtam.taurus',
            avatar: require('../../../images/vipcz/logo.png'),
            faceimg: require('../../../images/vipcz/face-Hoang.png'),
        },
        {
            nickname: 'Phuong Bui',
            facebook:'https://m.me/buiphuongdl',
            avatar: require('../../../images/vipcz/logo.png'),
            faceimg: require('../../../images/vipcz/face-Phuong.png'),
        },
    ],
    IN:[
        {
            nickname: 'Ruchika Tandon',
            whatsapp: '+91 9650686014',
            tel: '+91 9650686014',
            wechat: 'Ruchikatandon7',
            avatar: require('../../../images/vipcz/Ruchika.png'),
            weiimg: require('../../../images/vipcz/wei-Ruchika.png')

        },
        {
            nickname: 'Vani Sharma',
            whatsapp: '＋91 8368765271',
            tel: '＋91 8368765271',
            wechat: 'Gorav19_',
            avatar: require('../../../images/vipcz/Vani.png'),
            weiimg: require('../../../images/vipcz/wei-Vani.png')

        },
        {
            nickname: 'Vrinda',
            whatsapp: '91 9821446589',
            tel: '91 9821446589',
            wechat: 'bini_2018',
            avatar: require('../../../images/vipcz/Vrinda.png'),
            weiimg: require('../../../images/vipcz/wei-Vrinda.png')

        },
    ],
    CN: [
        {
            nickname: 'Lily',
            // whatsapp: '96177074',
            wechat: 'uphkviplily',
            line: 'uphkviplily',
            avatar: require('../../../images/vipcz/lily.jpg'),
            lineimg: require('../../../images/vipcz/line-lily.png'),
            weiimg: require('../../../images/vipcz/wei-lily.png')

        },
        {
            nickname: 'Anne',
            // whatsapp: '51362690',
            wechat: 'uplivehkvipanne',
            line: 'uplivehkvipanne',
            avatar: require('../../../images/vipcz/anne.jpg'),
            lineimg: require('../../../images/vipcz/line-anne.png'),
            weiimg: require('../../../images/vipcz/wei-anne.png')
        },
        {
            nickname: '大花',
            wechat: '1260217721',
            avatar: require('../../../images/vipcz/dahua.jpg'),
            weiimg: require('../../../images/vipcz/wei-dahua.png')
        },
        {
            nickname: '鱼鱼',
            wechat: 'uplivevipyu',
            line: 'uplivevipyu',
            avatar: require('../../../images/vipcz/yu.jpg'),
            lineimg: require('../../../images/vipcz/line-yuyu.png'),
            weiimg: require('../../../images/vipcz/wei-yuyu.png')
        },
        {
            nickname: 'Vivi',
            wechat: 'uplivevip',
            line: 'uplivevip',
            avatar: require('../../../images/vipcz/vivi.jpg'),
            lineimg: require('../../../images/vipcz/line-vivi.png'),
            weiimg: require('../../../images/vipcz/wei-vivi.png')
        },
        {
            nickname: '啾比',
            wechat: 'uplivevipju',
            line: 'uplivevipju',
            avatar: require('../../../images/vipcz/jiubi.jpg'),
            lineimg: require('../../../images/vipcz/line-qiubi.png'),
            weiimg: require('../../../images/vipcz/wei-qiubi.png')
        },
        {
            nickname: '艾瑪',
            wechat: 'uplivevipma',
            line: 'uplivevipma',
            avatar: require('../../../images/vipcz/emma.jpg'),
            lineimg: require('../../../images/vipcz/line-aima.png'),
            weiimg: require('../../../images/vipcz/wei-aima.png')
        },
        {
            nickname: 'Miko',
            wechat: 'uplivevipmi',
            line: 'uplivevipmi',
            avatar: require('../../../images/vipcz/miko.jpg'),
            lineimg: require('../../../images/vipcz/line-miko.png'),
            weiimg: require('../../../images/vipcz/wei-miko.png')
        },

        {
            nickname: 'Amy',
            wechat: '963002637',
            avatar: require('../../../images/vipcz/Amy.jpg'),
            weiimg: require('../../../images/vipcz/wei-amy.png')
        },
        {
            nickname: 'テイテイ(奶油)',
            wechat: 'uplivevipel',
            line: 'uplivevipel',
            avatar: require('../../../images/vipcz/naiyou.jpg'),
            lineimg: require('../../../images/vipcz/line-naiyou.png'),
            weiimg: require('../../../images/vipcz/wei-naiyou.png')
        },
        {
            nickname: '晶晶',
            wechat: '1046045875',
            avatar: require('../../../images/vipcz/jingjing.png'),
            weiimg: require('../../../images/vipcz/wei-jingjing.png')
        },


    ],
    BD:[
        {
            nickname: 'Zannatul_Mou',
            whatsapp: '+8801992029939',
            tel: '+8801992029939',
            avatar: require('../../../images/vipcz/logo.png')

        },
    ],
    MSL: [
        {
            nickname: 'Emy',
            whatsapp: '002-010-6821-5135',
            avatar: require('../../../images/vipcz/emy.jpg')
        },
        {
            nickname: 'Queena',
            whatsapp: '002-010-9827-8791',
            avatar: require('../../../images/vipcz/Queena.jpg')
        },
        {
            nickname: 'DoOoOoBa',
            whatsapp: '002-0109-875-2112',
            avatar: require('../../../images/vipcz/DoOoOoBa.jpg')
        },
        {
            nickname: 'Mariam',
            whatsapp: '002-010-1948-3770',
            avatar: require('../../../images/vipcz/Mariam.jpg')
        },
        {
            nickname: 'Nour',
            whatsapp: '002-010-973752905',
            avatar: require('../../../images/vipcz/Nour.jpg')
        },
        {
            nickname: 'Zahra',
            whatsapp: '002-010-9708-9881',
            avatar: require('../../../images/vipcz/zahra.jpg')
        },
        {
            nickname: 'Mohamed',
            whatsapp: '002-010-9773-4093',
            avatar: require('../../../images/vipcz/mohamed.jpg')
        }
    ]
}

export default vipList;



// WEBPACK FOOTER //
// ./js/mall/recharge/vipcz-config.js